import React from 'react';

import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';
import CancelRoundedIcon from '@mui/icons-material/CancelRounded';
import classNames from 'classnames';
import { TitleWithDescription } from '@infoods/lifebase-ui';

import classes from './StatusCell.module.scss';
import {
  CUSTOMER_STATUS,
  CustomerStatusType,
} from '../../../../../../../shared/constants/customer/customerStatus';
import { Status } from '../../../../../../../shared/components/ui-components';
import { getFormattedDate } from '../../../../../../../shared/utils/dateUtils';
import { localDataFormat } from '../../../../../../../shared/constants/apiDateFormat';

type StatusCellProps = {
  status: CustomerStatusType;
  accessTillDate?: string;
};

const StatusCell = ({ status, accessTillDate }: StatusCellProps) => {
  const renderContent = () => {
    switch (status) {
      case CUSTOMER_STATUS.ACTIVE:
        return (
          <Status icon={<CheckCircleRoundedIcon fontSize="large" color="success" />}>
            Active
          </Status>
        );
      case CUSTOMER_STATUS.CANCELED:
        return (
          <Status icon={<CancelRoundedIcon fontSize="large" color="error" />}>
            <TitleWithDescription
              title="Canceled"
              titleFont="inherit"
              className={classes.cancelledStatus}
              withoutGap
              description={
                accessTillDate ? (
                  <div
                    className={classNames(
                      classes.cancelledStatusDescription,
                      'private-info',
                    )}
                  >
                    Access till the {getFormattedDate(accessTillDate, localDataFormat)}
                  </div>
                ) : null
              }
            />
          </Status>
        );
      default:
        return <div>{status}</div>;
    }
  };

  return <div className={classes.statusCell}>{renderContent()}</div>;
};

export { StatusCell };
